const DOCUMENT = 'SSO_';

const actions = {
  LOGIN_WITH_SSO_REQUEST: DOCUMENT + 'LOGIN_WITH_SSO_REQUEST',
  LOGIN_WITH_SSO_SUCCESS: DOCUMENT + 'LOGIN_WITH_SSO_SUCCESS',
  LOGIN_WITH_SSO_ERROR: DOCUMENT + 'LOGIN_WITH_SSO_ERROR',

  loginWithSSORequest: payload => ({
    type: actions.LOGIN_WITH_SSO_REQUEST,
    payload,
  }),

  loginWithSSOSuccess: () => ({
    type: actions.LOGIN_WITH_SSO_SUCCESS,
  }),

  loginWithSSOError: () => ({
    type: actions.LOGIN_WITH_SSO_ERROR,
  }),
};

export default actions;
